"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountAccepterList = exports.AccepterList = void 0;
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var AccepterBlock_1 = require("./AccepterBlock");
var c = (0, BemBuilder_1.default)("accepter-list");
var AccepterList = (function (_super) {
    __extends(AccepterList, _super);
    function AccepterList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccepterList.prototype.render = function () {
        var accepters = this.props.accepters;
        if (accepters.length < 1) {
            return null;
        }
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement("h3", { className: c("heading") }, "Accepted by"),
            accepters.map(function (accepter) {
                return (react_1.default.createElement(AccepterBlock_1.AccepterBlock, { key: accepter.name, name: accepter.name, date: accepter.acceptedAt, esignature: accepter.esignature, esignatureMethod: accepter.signatureMethod }));
            })));
    };
    return AccepterList;
}(react_1.default.Component));
exports.AccepterList = AccepterList;
var mountAccepterList = function (mountReactComponent, props) {
    return mountReactComponent(react_1.default.createElement(AccepterList, __assign({}, props)));
};
exports.mountAccepterList = mountAccepterList;
